import Seo from "../components/Seo";
import { LogoMark, LogoWord } from "../components/Logo";

const Layout = ({ title, children }) => (
  <div className="bg-[#0C0D0E] min-h-screen text-gray-300" data-testid={`legal-${title.slice(0, 8).replace(/\s/g, "-").toLowerCase()}`}>
    <header className="border-b border-[#2E333D]/60 px-4 sm:px-6 lg:px-8 h-16 flex items-center">
      <a href="/" className="flex items-center gap-2.5" data-testid="legal-logo">
        <LogoMark size={30} />
        <LogoWord />
      </a>
    </header>
    <main className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <h1 className="font-display text-3xl sm:text-4xl font-bold uppercase tracking-tight text-[#F9FAFB] mb-10">{title}</h1>
      <div className="space-y-8 text-sm sm:text-base leading-relaxed [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-bold [&_h2]:uppercase [&_h2]:text-[#FFC700] [&_h2]:mt-8 [&_h2]:mb-3 [&_p]:text-gray-400">
        {children}
      </div>
      <a href="/" className="mt-12 inline-block text-sm text-gray-500 hover:text-[#FFC700] transition-colors">← Retour au site</a>
    </main>
  </div>
);

export function MentionsLegales() {
  return (
    <Layout title="Mentions légales">
      <Seo title="Mentions légales — STOCKBOX 8" noindex />
      <h2>Éditeur du site</h2>
      <p>
        Le site STOCKBOX 8 est édité par <strong className="text-gray-200">SAS Curti Franck</strong>, société par actions simplifiée.
      </p>
      <p>
        Siège social : [à compléter avant mise en ligne] — SIREN : [à compléter] — RCS : [à compléter] —
        Capital social : [à compléter] — Email de contact : stockbox8@hotmail.com — Téléphone : [à compléter].
      </p>
      <h2>Directeur de la publication</h2>
      <p>Franck Curti, en qualité de représentant de SAS Curti Franck.</p>
      <h2>Hébergement</h2>
      <p>Hébergeur du site : [à compléter avant mise en ligne — nom, adresse et téléphone de l'hébergeur].</p>
      <h2>Produit en développement</h2>
      <p>
        STOCKBOX 8 est un produit actuellement en développement. Les visuels présentés sur ce site sont des
        concepts non contractuels. Les caractéristiques, dimensions, prix et fonctionnalités présentés sont
        indicatifs et susceptibles d'évoluer avant toute commercialisation.
      </p>
      <h2>Propriété intellectuelle</h2>
      <p>
        L'ensemble des contenus du site (textes, visuels, logo STOCKBOX 8) est la propriété de SAS Curti Franck.
        Toute reproduction sans autorisation est interdite.
      </p>
    </Layout>
  );
}

export function PolitiqueConfidentialite() {
  return (
    <Layout title="Politique de confidentialité">
      <Seo title="Politique de confidentialité — STOCKBOX 8" noindex />
      <h2>Responsable de traitement</h2>
      <p>
        SAS Curti Franck ([adresse à compléter]) est responsable du traitement des données collectées sur ce site.
        Contact : stockbox8@hotmail.com.
      </p>
      <h2>Données collectées</h2>
      <p>
        Dans le cadre de l'étude de marché STOCKBOX 8, nous collectons via le questionnaire : prénom, email,
        métier, ville, région, nombre de véhicules professionnels, vos réponses sur l'intérêt du produit,
        du prix et du test prototype, ainsi que vos commentaires libres. Nous collectons également des données
        de mesure d'audience (pages vues, appareil, paramètres UTM des campagnes publicitaires).
      </p>
      <h2>Finalités et base légale</h2>
      <p>
        Vos réponses servent exclusivement à valider l'intérêt du marché français pour STOCKBOX 8 avant sa
        production : analyse de la demande, identification des testeurs, mesure de l'intention d'achat
        (base légale : votre consentement). Les communications marketing ne sont envoyées qu'avec votre
        consentement explicite.
      </p>
      <h2>Durée de conservation</h2>
      <p>Vos données sont conservées pendant la durée de l'étude de pré-lancement, puis au maximum [durée à compléter — ex. 24 mois] après votre dernière interaction.</p>
      <h2>Vos droits</h2>
      <p>
        Conformément au RGPD, vous disposez de droits d'accès, de rectification, d'effacement, de limitation,
        d'opposition et de portabilité. Pour exercer ces droits ou demander la suppression de vos données,
        contactez-nous à stockbox8@hotmail.com. Vous pouvez introduire une réclamation auprès de la CNIL
        (www.cnil.fr).
      </p>
      <h2>Sécurité</h2>
      <p>
        Les données sont stockées de manière sécurisée. L'accès à la base de prospects est strictement réservé
        à l'administrateur du site, protégé par authentification.
      </p>
    </Layout>
  );
}

export function PolitiqueCookies() {
  return (
    <Layout title="Politique cookies">
      <Seo title="Politique cookies — STOCKBOX 8" noindex />
      <h2>Cookies utilisés</h2>
      <p>
        Ce site utilise des identifiants de mesure d'audience stockés localement sur votre appareil
        (identifiant visiteur anonyme, choix de consentement, variante de prix affichée dans le cadre
        de l'étude A/B). Ces éléments ne permettent pas de vous identifier personnellement.
      </p>
      <h2>Mesure d'audience</h2>
      <p>
        Des outils de mesure d'audience (dont Google Analytics 4, lorsqu'il sera activé) peuvent être utilisés
        pour comprendre la fréquentation du site : pages vues, appareil utilisé, provenance et campagnes
        publicitaires. Ces outils ne sont chargés qu'avec votre consentement.
      </p>
      <h2>Votre choix</h2>
      <p>
        Lors de votre première visite, un bandeau vous permet d'accepter ou de refuser les cookies de mesure
        d'audience. Vous pouvez modifier votre choix à tout moment en supprimant les données du site dans votre
        navigateur : la bannière de consentement réapparaîtra.
      </p>
    </Layout>
  );
}
